import React from 'react'
import { useCart } from '../contextreducer/ContextReducer';

export default function Subtotal({price}) {

    const data = useCart()
    
    return (
        <div className="sub_item">
            <h4>Subtotal  ({data.length} item):<strong style={{ fontWeight: "700", color: "#111" }}> ₹{price}</strong></h4>
        </div>
    )
}
